import ElementAttributes from '../definitions/ElementAttributes';
import scrollIntoView from './scrollIntoView';


export default function scrollToCalculatorStep(stepNumber) {
    const currentStepElement = document.querySelector(`[${ElementAttributes.CALCULATOR_STEP_KEY}='${stepNumber}']`);

    if (!currentStepElement) {
        throw new Error(`[scrollToCalculatorStep] Cannot find calculator step number ${stepNumber} in the document.`);
    }

    return scrollIntoView(currentStepElement, {
        scrollMode: 'always',
        duration: 500,
    });
}
